/**
 * Safety Module
 *
 * @version 1.0
 * @module core/modules/safety
 *
 * @description
 * Módulo de Seguridad Urbana: cámaras, alarmas, puntos de emergencia.
 * Auto-registro en el moduleRegistry al importarse.
 */

import { moduleRegistry } from '../../module-registry';
import { SafetyTabbedPanel } from './SafetyTabbedPanel';

export { SafetyTabbedPanel };

/* ===== AUTO-REGISTRO DEL MÓDULO ===== */

moduleRegistry.register({
  id: 'safety',
  leftPanel: SafetyTabbedPanel,
  enabledByDefault: false,
});
